module.exports = __webpack_public_path__ + "static/media/text-logo-1.3591642c.svg";